export interface RecommendationItem {
  recommendation_id: number | null;
  slot_type: 'pinned' | 'algorithmic' | 'excluded';
  slot_position: number | null;
  content_type: 'featured_article' | 'blog' | 'trail' | 'blog_post';
  content_id: number;
  title: string;
  description: string;
  image: string;
  meta_label: string;
  url: string;
  mutual_exclude?: boolean;
}

export interface RecommendationsAdminState {
  pinned: RecommendationItem[];
  excluded: RecommendationItem[];
  suggestions: RecommendationItem[];
}

export interface ContentSearchResult {
  content_type: 'featured_article' | 'blog' | 'trail' | 'blog_post';
  content_id: number;
  title: string;
  description: string;
  image: string;
  meta_label: string;
}

export interface UrlLookupResult {
  found: boolean;
  content_type: string | null;
  content_id: number | null;
  title: string | null;
  description: string | null;
  image: string | null;
  meta_label: string | null;
}

export interface RecommendationsState {
  bySource: Record<string, RecommendationItem[]>;
  adminBySource: Record<string, RecommendationsAdminState>;
  loadingBySource: Record<string, boolean>;
  adminLoadingBySource: Record<string, boolean>;
  errorBySource: Record<string, string | null>;
  searchResults: ContentSearchResult[];
  searchLoading: boolean;
  urlLookupResult: UrlLookupResult | null;
  urlLookupLoading: boolean;
}

export function sourceKey(sourceType: string, sourceId: number): string {
  return `${sourceType}:${sourceId}`;
}
